<template>
  <vue-ladda
    :loading="cartUpdating"
    data-style="zoom-in"
    :button-class="buttonClass"
    @click.prevent="goToCartDetail()"
    class="bg-primary text-white rounded"
    :disabled="cart.items.length === 0 || cartUpdating"
  >
    <font-awesome-icon icon="shopping-cart" class="mr-2" />
    {{ cart && cart.items ? cart.items.length : 0 }}
  </vue-ladda>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "MarketCartButton",
  computed: {
    ...mapGetters("connections", ["familyId"]),
    ...mapState("shop", ["cart", "cartUpdating"]),
    buttonClass() {
      if (this.type === "filled") {
        return "btn btn-primary";
      } else if (this.type === "outline") {
        return "btn btn-outline-primary";
      }
      return "btn btn-outline-primary";
    },
  },
  methods: {
    goToCartDetail() {
      const familyId = this.familyId;
      const marketId = this.cart.market;
      this.$router.push({
        name: "UserMarketCartDetail",
        params: { familyId, marketId },
      });
    },
  },
  props: {
    type: {
      type: String,
      default: "outline",
      validator: (value) => ["outline", "filled"].includes(value),
      required: false,
    },
  },
};
</script>
